import React, { FC } from "react";
import ReactSelect, { components, ContainerProps, Props } from "react-select";

import styles from "../../constants/reactSelectStyle";

type SelectProps = Props & { ["data-test-id"]?: string };

// カスタムプロパティ:data-test-idのためのreact-selectのラッパー
export const Select: FC<SelectProps> = ({ "data-test-id": dataTestId, ...props }) => {
  return (
    <ReactSelect
      styles={styles}
      menuPortalTarget={document.querySelector("body")}
      {...props}
      components={{
        SelectContainer: ({ children, innerProps, ...props }: ContainerProps) => {
          return (
            <components.SelectContainer
              {...props}
              innerProps={{
                ...innerProps,
                // @ts-ignore: カスタムプロパティ
                ["data-test-id"]: dataTestId,
              }}
            >
              {children}
            </components.SelectContainer>
          );
        },
      }}
    />
  );
};
